(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[188],{

/***/ 4766:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/board-member/[uid]",
      function () {
        return __webpack_require__(9404);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prismic_reactjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5833);
/* harmony import */ var prismic_reactjs__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prismic_reactjs__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1752);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);







var Head = function(param) {
    var data = param.data, canonical = param.canonical;
    var siteUrl = (0,next_config__WEBPACK_IMPORTED_MODULE_5__["default"])().publicRuntimeConfig.siteUrl;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var canonicalUrl = canonical === "/homepage" ? "".concat(siteUrl, "/").concat(router.locale) : "".concat(siteUrl, "/").concat(router.locale).concat(canonical);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "180x180",
                href: "/apple-touch-icon.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "32x32",
                href: "/favicon-32x32.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "16x16",
                href: "/favicon-16x16.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "manifest",
                href: "/site.webmanifest"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "mask-icon",
                href: "/safari-pinned-tab.svg",
                color: "#d6a560"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "msapplication-TileColor",
                content: "#ffffff"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "theme-color",
                content: "#ffffff"
            }),
            data.meta_title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: prismic_reactjs__WEBPACK_IMPORTED_MODULE_4__.RichText.asText(data.meta_title)
            }),
            !data.meta_title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: "VFI"
            }),
            data.meta_description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: prismic_reactjs__WEBPACK_IMPORTED_MODULE_4__.RichText.asText(data.meta_description)
            }),
            data.meta_title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: prismic_reactjs__WEBPACK_IMPORTED_MODULE_4__.RichText.asText(data.meta_title)
            }),
            data.meta_description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: prismic_reactjs__WEBPACK_IMPORTED_MODULE_4__.RichText.asText(data.meta_description)
            }),
            data.og_image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: data.og_image.url
            }),
            data.robots_index && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: data.robots_index ? "all" : "noindex"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            })
        ]
    });
};
Head.propTypes = {
    data: prop_types__WEBPACK_IMPORTED_MODULE_2___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_2___default().any))
};
/* harmony default export */ __webpack_exports__["Z"] = (Head);


/***/ }),

/***/ 9421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ member; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 24 modules
var withStyles = __webpack_require__(9438);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(3832);
;// CONCATENATED MODULE: ./components/member/style.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var styles = function(theme) {
    var _obj, _obj1, _obj2, _obj3, _obj4, _obj5, _obj6;
    return {
        aboutProfileWrapper: (_obj6 = {
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10)
        }, _defineProperty(_obj6, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(9)
        }), _defineProperty(_obj6, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8)
        }), _defineProperty(_obj6, "& .aboutProfile", (_obj5 = {
            borderRadius: 8,
            boxShadow: "0 23px 42px 0 rgba(106, 118, 154, 0.15)",
            display: "flex",
            padding: theme.spacing(4)
        }, _defineProperty(_obj5, theme.breakpoints.down("sm"), {
            display: "block",
            padding: theme.spacing(3, 3, 0)
        }), _defineProperty(_obj5, theme.breakpoints.down("xs"), {
            display: "block"
        }), _defineProperty(_obj5, "& .profileImg", (_obj = {
            maxHeight: 615,
            borderRadius: 8,
            objectFit: "cover"
        }, _defineProperty(_obj, theme.breakpoints.down("1200"), {
            maxHeight: 515
        }), _defineProperty(_obj, theme.breakpoints.down("sm"), {
            maxHeight: 415
        }), _defineProperty(_obj, theme.breakpoints.down("xs"), {
            maxHeight: "unset",
            width: "100%"
        }), _obj)), _defineProperty(_obj5, "& .profileDetails", (_obj4 = {
            display: "flex",
            flexDirection: "column",
            flex: 1,
            paddingLeft: theme.spacing(4)
        }, _defineProperty(_obj4, theme.breakpoints.down("sm"), {
            paddingLeft: theme.spacing(0),
            padding: theme.spacing(4, 0)
        }), _defineProperty(_obj4, theme.breakpoints.down("xs"), {
            padding: theme.spacing(4, 0)
        }), _defineProperty(_obj4, "& .name", {
            fontSize: 36,
            fontWeight: 900,
            lineHeight: 1.25,
            color: "#4c4c78",
            marginBottom: theme.spacing(1),
            "& h2": (_obj1 = {
                fontSize: 36,
                margin: 0
            }, _defineProperty(_obj1, theme.breakpoints.down("sm"), {
                fontSize: 28
            }), _defineProperty(_obj1, theme.breakpoints.down("xs"), {
                fontSize: 20
            }), _obj1)
        }), _defineProperty(_obj4, "& .role", {
            fontSize: 24,
            color: "#4c4c78",
            "& p": (_obj2 = {
                margin: 0,
                fontSize: 24
            }, _defineProperty(_obj2, theme.breakpoints.down("sm"), {
                fontSize: 20
            }), _defineProperty(_obj2, theme.breakpoints.down("xs"), {
                fontSize: 16
            }), _obj2)
        }), _defineProperty(_obj4, "& .about", {
            lineHeight: 1.78,
            color: "#4c4c78",
            marginTop: theme.spacing(4),
            marginBottom: theme.spacing(4),
            "& p": (_obj3 = {
                margin: 0,
                fontSize: 18
            }, _defineProperty(_obj3, theme.breakpoints.down("sm"), {
                fontSize: 16
            }), _defineProperty(_obj3, theme.breakpoints.down("xs"), {
                fontSize: 14
            }), _obj3)
        }), _obj4)), _obj5)), _obj6)
    };
};
/* harmony default export */ var style = (styles);

// EXTERNAL MODULE: ./components/CustomLink/index.js + 1 modules
var CustomLink = __webpack_require__(6833);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(5833);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
;// CONCATENATED MODULE: ./components/member/index.js












var Member = function(param) {
    var classes = param.classes, data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        className: classes.aboutProfileWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "aboutProfile",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "profileImg",
                    src: data.portrait_image.url
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "profileDetails",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "name",
                            children: prismic_reactjs.RichText.asText(data.name)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "role",
                            children: prismic_reactjs.RichText.asText(data.title)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "about",
                            children: prismic_reactjs.RichText.render(data.full_bio)
                        })
                    ]
                })
            ]
        })
    });
};
Member.propTypes = {
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var member = ((0,withStyles/* default */.Z)(style)(Member));


/***/ }),

/***/ 9404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _utils_additional_data_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1623);
/* harmony import */ var _utils_layout_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5385);
/* harmony import */ var _components_member__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9421);
/* harmony import */ var _components_Head__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4394);






var BoardMember = function(props) {
    var data = props.data, person = props.person;
    var setHeaderColor = (0,_utils_layout_context__WEBPACK_IMPORTED_MODULE_3__/* .useLayout */ .$Y)().setHeaderColor;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setHeaderColor(true);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Head__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                data: person.data,
                canonical: "/board-member/".concat(person.uid)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils_additional_data_context__WEBPACK_IMPORTED_MODULE_2__/* .AdditionalDataProvider */ .YZ, {
                value: props.additionalData,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_member__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    data: person.data
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (BoardMember);


/***/ }),

/***/ 1623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YZ": function() { return /* binding */ AdditionalDataProvider; },
/* harmony export */   "eP": function() { return /* binding */ useAdditionalData; }
/* harmony export */ });
/* unused harmony export AdditionalDataConsumer */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var AdditionalDataContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
var AdditionalDataProvider = AdditionalDataContext.Provider;
var AdditionalDataConsumer = AdditionalDataContext.Consumer;
var useAdditionalData = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(AdditionalDataContext);
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (AdditionalDataContext)));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,774,888,179], function() { return __webpack_exec__(4766); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);